webpackJsonp([43424109361899],{

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _P = __webpack_require__(11);
	
	var _P2 = _interopRequireDefault(_P);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactLink = function (_React$Component) {
	  _inherits(ContactLink, _React$Component);
	
	  function ContactLink(props) {
	    _classCallCheck(this, ContactLink);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = { mounted: false };
	    return _this;
	  }
	
	  ContactLink.prototype.componentDidMount = function componentDidMount() {
	    this.setState({ mounted: true });
	  };
	
	  ContactLink.prototype.render = function render() {
	    return _react2.default.createElement(
	      _P2.default,
	      { big: true },
	      'If you have any questions or feedback please',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        {
	          href: this.state.mounted ? 'mailto:me%40gauti.info' : '#',
	          target: '_blank',
	          rel: 'noopener'
	        },
	        'email me.'
	      )
	    );
	  };
	
	  return ContactLink;
	}(_react2.default.Component);
	
	exports.default = ContactLink;
	module.exports = exports['default'];

/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.List = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: ', ';\n  margin: ', ';\n'], ['\n  display: ', ';\n  margin: ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var List = exports.List = _styledComponents2.default.li(_templateObject, function (props) {
	  return props.inline ? 'inline-block' : 'block';
	}, function (props) {
	  return props.inline ? '2px .5rem' : '.5rem 0';
	});
	
	var LI = function LI(_ref) {
	  var children = _ref.children,
	      otherProps = _objectWithoutProperties(_ref, ['children']);
	
	  return _react2.default.createElement(
	    List,
	    otherProps,
	    children
	  );
	};
	
	LI.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = LI;

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.NavigationLinksWrap = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  align-items: center;\n  display: flex;\n  justify-content: space-around;\n  list-style-type: none;\n  margin: 50px auto 25px;\n  max-width: 800px;\n  padding: 0;\n'], ['\n  align-items: center;\n  display: flex;\n  justify-content: space-around;\n  list-style-type: none;\n  margin: 50px auto 25px;\n  max-width: 800px;\n  padding: 0;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  text-align: center;\n\n  a {\n    box-sizing: border-box;\n    color: ', ';\n    display: block;\n    font-size: 1.2rem;\n    line-height: 50px;\n    padding: 1rem 2rem;\n    transition: background-color 0.35s;\n    width: 170px;\n\n    &:before {\n      border: ', ';\n      border-width: 0 1px 1px 0;\n      content: \'\';\n      display: ', ';\n      margin-right: 15px;\n      padding: 5px;\n      transform: rotate(135deg) scale(2);\n      transition: transform 0.35s;\n    }\n\n    &:after {\n      border: ', ';\n      border-width: 0 1px 1px 0;\n      content: \'\';\n      display: ', ';\n      margin-left: 15px;\n      padding: 5px;\n      transform: rotate(-45deg) scale(2);\n      transition: transform 0.35s;\n    }\n\n    &:hover,\n    &:focus {\n      background-color: ', ';\n\n      &:before {\n        transform: rotate(135deg) scale(3);\n      }\n\n      &:after {\n        transform: rotate(-45deg) scale(3);\n      }\n    }\n  }\n'], ['\n  text-align: center;\n\n  a {\n    box-sizing: border-box;\n    color: ', ';\n    display: block;\n    font-size: 1.2rem;\n    line-height: 50px;\n    padding: 1rem 2rem;\n    transition: background-color 0.35s;\n    width: 170px;\n\n    &:before {\n      border: ', ';\n      border-width: 0 1px 1px 0;\n      content: \'\';\n      display: ', ';\n      margin-right: 15px;\n      padding: 5px;\n      transform: rotate(135deg) scale(2);\n      transition: transform 0.35s;\n    }\n\n    &:after {\n      border: ', ';\n      border-width: 0 1px 1px 0;\n      content: \'\';\n      display: ', ';\n      margin-left: 15px;\n      padding: 5px;\n      transform: rotate(-45deg) scale(2);\n      transition: transform 0.35s;\n    }\n\n    &:hover,\n    &:focus {\n      background-color: ', ';\n\n      &:before {\n        transform: rotate(135deg) scale(3);\n      }\n\n      &:after {\n        transform: rotate(-45deg) scale(3);\n      }\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(22);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var NavigationLinksWrap = exports.NavigationLinksWrap = _styledComponents2.default.ul(_templateObject);
	
	var Li = _styledComponents2.default.li(_templateObject2, function (props) {
	  return props.theme.gray;
	}, function (props) {
	  return 'solid ' + props.theme.gray;
	}, function (props) {
	  return props.prev ? 'inline-block' : 'none';
	}, function (props) {
	  return 'solid ' + props.theme.gray;
	}, function (props) {
	  return props.prev ? 'none' : 'inline-block';
	}, function (props) {
	  return props.theme.grayLight;
	});
	
	var NavigationLinks = function NavigationLinks(_ref) {
	  var nextLink = _ref.nextLink,
	      nextCopy = _ref.nextCopy,
	      prevLink = _ref.prevLink,
	      prevCopy = _ref.prevCopy;
	  return _react2.default.createElement(
	    NavigationLinksWrap,
	    null,
	    !!nextLink && !!nextCopy && _react2.default.createElement(
	      Li,
	      { prev: true },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: nextLink, title: 'Visit ' + nextCopy },
	        'Previous'
	      )
	    ),
	    !!prevLink && !!prevCopy && _react2.default.createElement(
	      Li,
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: prevLink, title: 'Visit ' + prevCopy },
	        'Next'
	      )
	    )
	  );
	};
	
	NavigationLinks.propTypes = {
	  nextLink: _propTypes2.default.string,
	  nextCopy: _propTypes2.default.string,
	  prevLink: _propTypes2.default.string,
	  prevCopy: _propTypes2.default.string
	};
	
	exports.default = NavigationLinks;

/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  font-size: 1rem;\n  line-height: 1.2;\n  ', ';\n'], ['\n  color: ', ';\n  font-size: 1rem;\n  line-height: 1.2;\n  ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var List = _styledComponents2.default.ul(_templateObject, function (props) {
	  return props.inverse ? '#ffffff' : '#000000';
	}, function (props) {
	  return props.inline ? 'padding-left: 0' : '';
	});
	
	var UL = function UL(_ref) {
	  var children = _ref.children,
	      otherProps = _objectWithoutProperties(_ref, ['children']);
	
	  return _react2.default.createElement(
	    List,
	    otherProps,
	    children
	  );
	};
	
	UL.propTypes = {
	  children: _propTypes2.default.node.isRequired
	};
	
	exports.default = UL;
	module.exports = exports['default'];

/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/nag-me-2.c545b090.jpg";

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/nag-me.7c04e4a1.jpg";

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  p {\n    margin-bottom: 25px;\n  }\n'], ['\n  p {\n    margin-bottom: 25px;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  padding: 0 10px;\n  text-align: center;\n'], ['\n  padding: 0 10px;\n  text-align: center;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  margin: 15px 0 35px;\n'], ['\n  margin: 15px 0 35px;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  margin: 15px 0;\n\n  a {\n    margin: 10px 15px;\n  }\n'], ['\n  margin: 15px 0;\n\n  a {\n    margin: 10px 15px;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  color: #47b346;\n\n  &:hover,\n  &:focus {\n    color: #148013;\n  }\n'], ['\n  color: #47b346;\n\n  &:hover,\n  &:focus {\n    color: #148013;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  color: #ff9500;\n\n  &:hover,\n  &:focus {\n    color: #cc6200;\n  }\n'], ['\n  color: #ff9500;\n\n  &:hover,\n  &:focus {\n    color: #cc6200;\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  color: #cc0f16;\n\n  &:hover,\n  &:focus {\n    color: #990000;\n  }\n'], ['\n  color: #cc0f16;\n\n  &:hover,\n  &:focus {\n    color: #990000;\n  }\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  align-content: center;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-evenly;\n  margin-top: 0;\n\n  ', '\n\n  ', '\n\n  ', '\n'], ['\n  align-content: center;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-evenly;\n  margin-top: 0;\n\n  ', '\n\n  ', '\n\n  ', '\n']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n    flex-wrap: nowrap;\n  '], ['\n    flex-wrap: nowrap;\n  ']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n    margin-top: -35px;\n  '], ['\n    margin-top: -35px;\n  ']),
	    _templateObject11 = _taggedTemplateLiteralLoose(['\n    margin-top: -100px;\n  '], ['\n    margin-top: -100px;\n  ']),
	    _templateObject12 = _taggedTemplateLiteralLoose(['\n  margin-bottom: 35px;\n  max-width: 300px;\n  width: 100%;\n\n  ', ';\n'], ['\n  margin-bottom: 35px;\n  max-width: 300px;\n  width: 100%;\n\n  ', ';\n']),
	    _templateObject13 = _taggedTemplateLiteralLoose(['\n    margin-bottom: 0;\n    max-width: 500px;\n    overflow: hidden;\n    width: 27%;\n  '], ['\n    margin-bottom: 0;\n    max-width: 500px;\n    overflow: hidden;\n    width: 27%;\n  ']),
	    _templateObject14 = _taggedTemplateLiteralLoose(['\n  margin-right: 10px;\n'], ['\n  margin-right: 10px;\n']),
	    _templateObject15 = _taggedTemplateLiteralLoose(['\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.35);\n\n  ', ';\n'], ['\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.35);\n\n  ', ';\n']),
	    _templateObject16 = _taggedTemplateLiteralLoose(['\n    box-shadow: -5px 0 15px rgba(0, 0, 0, .2);\n    transform: ', ';\n  '], ['\n    box-shadow: -5px 0 15px rgba(0, 0, 0, .2);\n    transform: ', ';\n  ']),
	    _templateObject17 = _taggedTemplateLiteralLoose(['\n  box-sizing: border-box;\n  padding: 0 10px;\n  text-align: left;\n  width: 100%;\n\n  ', ';\n'], ['\n  box-sizing: border-box;\n  padding: 0 10px;\n  text-align: left;\n  width: 100%;\n\n  ', ';\n']),
	    _templateObject18 = _taggedTemplateLiteralLoose(['\n    align-content: center;\n    display: flex;\n    flex-wrap: wrap;\n    padding: 0 0 0 10px;\n    width: 46%;\n  '], ['\n    align-content: center;\n    display: flex;\n    flex-wrap: wrap;\n    padding: 0 0 0 10px;\n    width: 46%;\n  ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Button = __webpack_require__(26);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Icon = __webpack_require__(52);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _H = __webpack_require__(27);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _UL = __webpack_require__(29);
	
	var _UL2 = _interopRequireDefault(_UL);
	
	var _LI = __webpack_require__(28);
	
	var _LI2 = _interopRequireDefault(_LI);
	
	var _P = __webpack_require__(11);
	
	var _P2 = _interopRequireDefault(_P);
	
	var _Helmet = __webpack_require__(51);
	
	var _Helmet2 = _interopRequireDefault(_Helmet);
	
	var _ResponsiveImg = __webpack_require__(34);
	
	var _ResponsiveImg2 = _interopRequireDefault(_ResponsiveImg);
	
	var _NavigationLinks = __webpack_require__(53);
	
	var _NavigationLinks2 = _interopRequireDefault(_NavigationLinks);
	
	var _Contact = __webpack_require__(49);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	var _nagMe = __webpack_require__(70);
	
	var _nagMe2 = _interopRequireDefault(_nagMe);
	
	var _nagMe3 = __webpack_require__(511);
	
	var _nagMe4 = _interopRequireDefault(_nagMe3);
	
	var _style = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var NagMe = _styledComponents2.default.article(_templateObject);
	
	var Header = _styledComponents2.default.header(_templateObject2);
	
	var Buttons = _styledComponents2.default.div(_templateObject3);
	
	var ButtonsExternal = _styledComponents2.default.div(_templateObject4);
	
	var ChromeLink = _styledComponents2.default.a(_templateObject5);
	
	var FireFoxLink = _styledComponents2.default.a(_templateObject6);
	
	var OperaLink = _styledComponents2.default.a(_templateObject7);
	
	var ContentWrapper = _styledComponents2.default.div(_templateObject8, _style.media.desktop(_templateObject9), _style.media.giant(_templateObject10), _style.media.ultraGiant(_templateObject11));
	
	var ContentImages = _styledComponents2.default.div(_templateObject12, _style.media.desktop(_templateObject13));
	
	var GithubIcon = _styledComponents2.default.span(_templateObject14);
	
	var ResponsiveImgWrap = _styledComponents2.default.div(_templateObject15, _style.media.desktop(_templateObject16, function (props) {
	  return props.right ? 'rotateZ(-15deg) translate(70px, 60px)' : 'rotateZ(-15deg) translate(25px, 50px)';
	}));
	
	var Content = _styledComponents2.default.div(_templateObject17, _style.media.desktop(_templateObject18));
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'main',
	    null,
	    _react2.default.createElement(_Helmet2.default, {
	      title: 'Gowtham Selvaraj (Gauti) Project - Nag Me - Browser extension to nag users',
	      description: 'Nag me notifies users of routine tasks. Some use cases of Nag Me are to notify to drink water, to take a walk, to relax your eyes and so on while you are on your computer.',
	      image: _nagMe2.default,
	      path: '/projects/nag-me'
	    }),
	    _react2.default.createElement(
	      NagMe,
	      null,
	      _react2.default.createElement(
	        Header,
	        null,
	        _react2.default.createElement(
	          _H2.default,
	          null,
	          'Nag Me'
	        ),
	        _react2.default.createElement(
	          _P2.default,
	          { bigger: true },
	          'Browser extension to nag users'
	        ),
	        _react2.default.createElement(
	          ButtonsExternal,
	          null,
	          _react2.default.createElement(
	            _UL2.default,
	            { inline: true },
	            _react2.default.createElement(
	              _LI2.default,
	              { inline: true },
	              _react2.default.createElement(
	                ChromeLink,
	                {
	                  href: 'https://chrome.google.com/webstore/detail/nag-me/jhppmbkjpboolciccfleojhinfjjdfmd',
	                  title: 'Visit Nag Me Chrome Extension Page',
	                  target: '_blank',
	                  rel: 'noopener'
	                },
	                _react2.default.createElement(_Icon2.default, { chrome: true }),
	                ' Chrome'
	              )
	            ),
	            _react2.default.createElement(
	              _LI2.default,
	              { inline: true },
	              _react2.default.createElement(
	                FireFoxLink,
	                {
	                  href: 'https://addons.mozilla.org/en-US/firefox/addon/nag-me/',
	                  title: 'Visit Nag Me Firefox Extension Page',
	                  target: '_blank',
	                  rel: 'noopener'
	                },
	                _react2.default.createElement(_Icon2.default, { firefox: true }),
	                ' Firefox'
	              )
	            ),
	            _react2.default.createElement(
	              _LI2.default,
	              { inline: true },
	              _react2.default.createElement(
	                OperaLink,
	                {
	                  href: 'https://addons.opera.com/en/extensions/details/nag-me/',
	                  title: 'Visit Nag Me Opera Extension Page',
	                  target: '_blank',
	                  rel: 'noopener'
	                },
	                _react2.default.createElement(_Icon2.default, { opera: true }),
	                ' Opera'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          Buttons,
	          null,
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              link: true,
	              bordered: true,
	              small: true,
	              href: 'https://github.com/gautiselvaraj/nag-me',
	              title: 'Visit Nag Me Github Repo',
	              target: '_blank',
	              rel: 'noopener'
	            },
	            _react2.default.createElement(
	              GithubIcon,
	              null,
	              _react2.default.createElement(_Icon2.default, { github: true })
	            ),
	            'Github'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        ContentWrapper,
	        null,
	        _react2.default.createElement(
	          ContentImages,
	          null,
	          _react2.default.createElement(
	            ResponsiveImgWrap,
	            null,
	            _react2.default.createElement(_ResponsiveImg2.default, {
	              src: _nagMe2.default,
	              alt: 'Nag Me Browser Extension'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          Content,
	          null,
	          _react2.default.createElement(
	            _P2.default,
	            { big: true },
	            'Nag me notifies users of routine tasks. Nag me notifications are soft (doesn\'t ring and auto closes) so use it for low priority tasks only. Some use cases of Nag Me are to notify to drink water, to take a walk, to relax your eyes and so on while you are on your computer. Nag Me works in Google Chrome, Firefox, and Opera.'
	          ),
	          _react2.default.createElement(
	            _P2.default,
	            { big: true },
	            'I used React (Create React App), Redux, Immutable.js, Jest, React-Motion, and styled-components for Nag Me. I utilized WebExtensions API along with Mozilla\'s webextension-polyfill.'
	          ),
	          _react2.default.createElement(_Contact2.default, null)
	        ),
	        _react2.default.createElement(
	          ContentImages,
	          null,
	          _react2.default.createElement(
	            ResponsiveImgWrap,
	            { right: true },
	            _react2.default.createElement(_ResponsiveImg2.default, {
	              src: _nagMe4.default,
	              alt: 'Browser extension to notify users of routined tasks'
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_NavigationLinks2.default, {
	      prevLink: '/projects/compare-movies/',
	      prevCopy: 'Compare Movies',
	      nextLink: '/projects/react-shorten/',
	      nextCopy: 'React Shorten'
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-nag-me-js-b59a64883050865e97d4.js